import { Injectable }       from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }                   from '../api/api.service';
import { CountryTypesModel }            from '../sessions/models/session.country-types';
import { ImportColumnModel }            from '../imports/typings/imports.column';
import { ImportTransformFunctionModel } from '../imports/typings/imports.transform-function';
import { NewCountryTypeComponent }      from './countries.new-country-type.component';
import { NewStateTypeComponent }        from './countries.new-state-type.component';
import { StateTypeModel }               from './typings/countries.state-type';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  constructor (
    private apiService      : ApiService,
    private modalService    : NgbModal,
    private translateService: TranslateService
  ) {}

  addNewType () : ng.IPromise<CountryTypesModel> {
    const modal = this.modalService.open(NewCountryTypeComponent);

    return modal.result;
  }

  addNeStateType ( country : CountryTypesModel ) : ng.IPromise<StateTypeModel> {
    const modal = this.modalService.open(NewStateTypeComponent);

    modal.componentInstance.country = country;

    return modal.result;
  }

  canDeleteSate ( state : StateTypeModel ) : ng.IPromise<boolean> {
    return this.apiService.get('/state_types/can_destroy', [
        state.country_code,
        state.code
      ]);
  }

  create ( country : CountryTypesModel ) : ng.IPromise<CountryTypesModel> {
    return this.apiService.post('/country_types', country, 'country_type');
  }

  createStateType ( state : StateTypeModel ) : ng.IPromise<StateTypeModel> {
    return this.apiService.post('/state_types', state, 'state_type');
  }

  deleteSate ( state : StateTypeModel ) : ng.IPromise<any> {
    return this.apiService.post('/state_type/delete_state', {
        code        : state.code,
        country_code: state.country_code
      }, 'state_type');
  }

  get () : ng.IPromise<Array<CountryTypesModel>> {
    return this.apiService.get('/system/country_types');
  }

  getStates ( country : CountryTypesModel ) : ng.IPromise<Array<StateTypeModel>> {
    return this.apiService.get('/system/states_for_country', country.code);
  }

  getStateTypeColumns () : ng.IPromise<Array<ImportColumnModel>> {
    return this.apiService.get('/imports/our_column_details', 'state_types');
  }

  getStateTypeTransformFunctions () : ng.IPromise<Array<ImportTransformFunctionModel>> {
    return this.apiService.get('/imports/available_actions', 'state_types');
  }

  removeState ( state : StateTypeModel ) : ng.IPromise<any> {
    return this.canDeleteSate(state)
      .then(( deletable : boolean ) => deletable
        ? this.deleteSate(state)
        : Promise.reject(this.translateService.instant('JS_SPACE.MESSAGES.COMPANIES_USING_GROUP_CANNOT_DELETE'))
      );
  }

  update ( country : CountryTypesModel ) : ng.IPromise<any> {
    return this.apiService.patch('/country_type', country, 'country_type');
  }
}
